/**
 * Single source of truth for the top-level `totals.tenderTotal` sent to the
 * billOfQuantities / boq-versions APIs. Always derived by summing the two
 * grandTotal values actually placed in `billOfQuantities[0]` — never computed
 * independently — so it can never drift out of sync with what those endpoints
 * are also storing under `billOfQuantities[0].groundworks`/`.roadAndSewers`.
 */

export interface BoqEntryTotals {
  groundworks?: { totals?: { grandTotal?: number } };
  roadAndSewers?: { totals?: { grandTotal?: number } };
}

export const calculateBoqTenderTotal = (
  boqEntry: BoqEntryTotals | undefined
): number => {
  const groundworksGrandTotal = boqEntry?.groundworks?.totals?.grandTotal || 0;
  const roadsAndSewersGrandTotal = boqEntry?.roadAndSewers?.totals?.grandTotal || 0;
  return groundworksGrandTotal + roadsAndSewersGrandTotal;
};
